export default "__VITE_ASSET__5054P$mc__"